var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.718,
    height: 47.622,
    viewBox: "0 0 48.718 47.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105760",
    "data-name": "Group 105760",
    transform: "translate(-1009 -262.811)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 24.359,
    cy: 23.811,
    rx: 24.359,
    ry: 23.811,
    transform: "translate(1009 262.811)",
    fill: "#29c6f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_5a3bb1e465466fe9db5eb51019590503",
    "data-name": "5a3bb1e465466fe9db5eb51019590503",
    transform: "translate(1021 274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106323",
    "data-name": "Path 106323",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106324",
    "data-name": "Path 106324",
    fill: "#ffffff",
    d: "M16,6v6a2.006,2.006,0,0,0,2,2h1v7a1,1,0,0,0,2,0V3.13a1.009,1.009,0,0,0-1.24-.98C17.6,2.68,16,4.51,16,6ZM11,9H9V3A1,1,0,0,0,7,3V9H5V3A1,1,0,0,0,3,3V9a4,4,0,0,0,4,4v8a1,1,0,0,0,2,0V13a4,4,0,0,0,4-4V3a1,1,0,0,0-2,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.125962483301349ba0a3ae5424ba688f.svg";
export { ForwardRef as ReactComponent };